import AddCommentButton from './AddCommentButton';
import { lightSanitiseText } from '../utils/utils';
import CancelButton from '../CancelButton';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import React from 'react';
import ProjectLanguageSelector from '../ProjectLanguageSelector';
import TitledPanel from '../TitledPanel';
import TitledTextField from '../TitledTextField';
import PrimaryButton from '../PrimaryButton';
import { globalStyles } from '../style/gstheme';

const styles = theme => {
    return Object.assign({
    }, globalStyles);
};

class AddDiscussionItemDialog extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: this.props.open,
            text: "",
            lang: this.props.defaultLang
        };
    }

    handleClickOpen = () => {
        this.setState({
            open: true,
            lang: this.props.defaultLang
        });
    };

    addItem = () => {
        this.props.onAddItem(this.state.lang, this.state.text);
        this.exitAddItem();
    };

    exitAddItem = () => {
        this.setState({ open: false, text: "", lang: this.props.defaultLang });
    };

    selectLanguage = (lang) => this.setState({ lang });

    handleChange = event => {
        const t = event.target;
        const cleanText = lightSanitiseText(t.value);
        this.setState({ [t.name]: cleanText });
    };

    render() {

        const { classes, name } = this.props;
        const { text, lang } = this.state;

        return (
            <React.Fragment>
                <AddCommentButton onClick={this.handleClickOpen}/>
                <Dialog
                    data-test="add-discussion-item-dialog"
                    maxWidth="md"
                    fullWidth
                    classes={{
                        paperWidthMd: classes.mediumDialog
                    }}
                    open={this.state.open}
                    onClose={this.exitAddLabel}
                    aria-labelledby="text-dialog-title">
                    <DialogTitle data-test="add-discussion-item-title" disableTypography className={classes.mainHeading} id="text-dialog-title">Add Comment</DialogTitle>
                    <DialogContent data-test="add-discussion-item-dialog" style={{ height: '290px' }}>
                        <TitledPanel title="Language">
                            <ProjectLanguageSelector selectedLang={lang} includeLabel={false} onSelect={this.selectLanguage} />
                        </TitledPanel>
                        <form autoComplete="off" noValidate="novalidate">
                            <TitledTextField
                                dataTest="language-text"
                                name="text"
                                title={name || "Text"}
                                margin={true}
                                placeholder="Enter your comment"
                                autoFocus={true}
                                required={true}
                                text={text}
                                multiline={true}
                                rows={3}
                                maxLength={500}
                                onEnter={text.length > 0 && lang !== "" ? this.addItem : null}
                                onChange={this.handleChange} />
                        </form>
                    </DialogContent>
                    <DialogActions className={classes.dialogActions}>
                        <CancelButton onClick={this.exitAddItem} />
                        <PrimaryButton
                            dataTest="add-discussion-item-button"
                            disabled={lang === "" || text.length === 0}
                            onClick={this.addItem}>Submit</PrimaryButton>
                    </DialogActions>
                </Dialog>
            </React.Fragment>
        );
    }
}

AddDiscussionItemDialog.defaultProps = {
    open: false
};

AddDiscussionItemDialog.propTypes = {
    classes: PropTypes.object,
    open: PropTypes.bool,
    defaultLang: PropTypes.string.isRequired,
    onAddItem: PropTypes.func.isRequired
};

export default withStyles(styles)(AddDiscussionItemDialog);